import { computed } from 'vue'
import _ from 'lodash'
import {
  ArrowPathIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  CalculatorIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  CloudArrowUpIcon,
  ComputerDesktopIcon,
  CreditCardIcon,
  DocumentCheckIcon,
  EnvelopeOpenIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  EyeIcon,
  FlagIcon,
  HomeIcon,
  IdentificationIcon,
  InformationCircleIcon,
  LanguageIcon,
  LightBulbIcon,
  LinkIcon,
  LinkSlashIcon,
  LockClosedIcon,
  MagnifyingGlassCircleIcon,
  MoonIcon,
  NewspaperIcon,
  PencilSquareIcon,
  PresentationChartLineIcon,
  ShareIcon,
  ShieldExclamationIcon,
  ShoppingCartIcon,
  SunIcon,
  TagIcon,
  TrashIcon,
  UserCircleIcon,
  UserGroupIcon,
  UserPlusIcon,
  UsersIcon,
  WrenchScrewdriverIcon,
  XCircleIcon
} from '@heroicons/vue/24/outline'
import {
  ArrowPathIcon as ArrowPathIconSolid,
  BriefcaseIcon as BriefcaseIconSolid,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconSolid,
  CheckCircleIcon as CheckCircleIconSolid,
  ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconSolid,
  ClipboardDocumentListIcon as ClipboardDocumentListIconSolid,
  ClockIcon as ClockIconSolid,
  CloudArrowUpIcon as CloudArrowUpIconSolid,
  DocumentCheckIcon as DocumentCheckIconSolid,
  ExclamationCircleIcon as ExclamationCircleIconSolid,
  ExclamationTriangleIcon as ExclamationTriangleIconSolid,
  EyeIcon as EyeIconSolid,
  FlagIcon as FlagIconSolid,
  IdentificationIcon as IdentificationIconSolid,
  InformationCircleIcon as InformationCircleIconSolid,
  LightBulbIcon as LightBulbIconSolid,
  LinkIcon as LinkIconSolid,
  LinkSlashIcon as LinkSlashIconSolid,
  NewspaperIcon as NewspaperIconSolid,
  PresentationChartLineIcon as PresentationChartLineIconSolid,
  ShoppingCartIcon as ShoppingCartIconSolid,
  TagIcon as TagIconSolid,
  TrashIcon as TrashIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  UsersIcon as UsersIconSolid,
  WrenchScrewdriverIcon as WrenchScrewdriverIconSolid,
  XCircleIcon as XCircleIconSolid
} from '@heroicons/vue/24/solid'

import {
  BriefcaseIcon as BriefcaseIconMini,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconMini,
  CheckCircleIcon as CheckCircleIconMini,
  ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconMini,
  ClipboardDocumentListIcon as ClipboardDocumentListIconMini,
  CloudArrowUpIcon as CloudArrowUpIconMini,
  DocumentCheckIcon as DocumentCheckIconMini,
  EyeIcon as EyeIconMini,
  FlagIcon as FlagIconMini,
  IdentificationIcon as IdentificationIconMini,
  LightBulbIcon as LightBulbIconMini,
  LinkIcon as LinkIconMini,
  LinkSlashIcon as LinkSlashIconMini,
  NewspaperIcon as NewspaperIconMini,
  PresentationChartLineIcon as PresentationChartLineIconMini,
  ShoppingCartIcon as ShoppingCartIconMini,
  TagIcon as TagIconMini,
  TrashIcon as TrashIconMini,
  UserGroupIcon as UserGroupIconMini,
  UsersIcon as UsersIconMini,
  WrenchScrewdriverIcon as WrenchScrewdriverIconMini
} from '@heroicons/vue/20/solid'

import { OhVueIcon } from 'oh-vue-icons'
import FormSmIcon from '@/Components/App/Global/Icons/FormSmIcon.vue'
import NotePadSmIcon from '@/Components/App/Global/Icons/NotePadSmIcon.vue'
import BriefcaseSmIcon from '@/Components/App/Global/Icons/BriefcaseSmIcon.vue'
import TargetSmIcon from '@/Components/App/Global/Icons/TargetSmIcon.vue'
import FolderSmIcon from '@/Components/App/Global/Icons/FolderSmIcon.vue'
import ChartSmIcon from '@/Components/App/Global/Icons/ChartSmIcon.vue'
import IdentificationSmIcon
  from '@/Components/App/Global/Icons/IdentificationSmIcon.vue'
import UserPlusSmIcon from '@/Components/App/Global/Icons/UserPlusSmIcon.vue'
import PieChartSmIcon from '@/Components/App/Global/Icons/PieChartSmIcon.vue'
import EnvelopeOpenSmIcon
  from '@/Components/App/Global/Icons/EnvelopeOpenSmIcon.vue'
import ChatSmIcon from '@/Components/App/Global/Icons/ChatSmIcon.vue'
import ShieldLockSmIcon
  from '@/Components/App/Global/Icons/ShieldLockSmIcon.vue'
import ShopSmIcon from '@/Components/App/Global/Icons/ShopSmIcon.vue'
import PuzzleSmIcon from '@/Components/App/Global/Icons/PuzzleSmIcon.vue'
import FlagSmIcon from '@/Components/App/Global/Icons/FlagSmIcon.vue'
import LightBulbSmIcon from '@/Components/App/Global/Icons/LightBulbSmIcon.vue'
import NewsSmIcon from '@/Components/App/Global/Icons/NewsSmIcon.vue'
import CloudUploadSmIcon
  from '@/Components/App/Global/Icons/CloudUploadSmIcon.vue'
import TrashSmIcon from '@/Components/App/Global/Icons/TrashSmIcon.vue'
import TagSmIcon from '@/Components/App/Global/Icons/TagSmIcon.vue'
import FormLgIcon from '@/Components/App/Global/Icons/FormLgIcon.vue'
import NotePadLgIcon from '@/Components/App/Global/Icons/NotePadLgIcon.vue'
import BriefcaseLgIcon from '@/Components/App/Global/Icons/BriefcaseLgIcon.vue'
import FolderLgIcon from '@/Components/App/Global/Icons/FolderLgIcon.vue'
import TargetLgIcon from '@/Components/App/Global/Icons/TargetLgIcon.vue'
import ChartLgIcon from '@/Components/App/Global/Icons/ChartLgIcon.vue'
import IdentificationLgIcon
  from '@/Components/App/Global/Icons/IdentificationLgIcon.vue'
import ShopLgIcon from '@/Components/App/Global/Icons/ShopLgIcon.vue'
import FlagLgIcon from '@/Components/App/Global/Icons/FlagLgIcon.vue'
import LightBulbLgIcon from '@/Components/App/Global/Icons/LightBulbLgIcon.vue'
import HomeSmIcon from '@/Components/App/Global/Icons/HomeSmIcon.vue'
import InformationLgIcon
  from '@/Components/App/Global/Icons/InformationLgIcon.vue'
import ExclamationLgIcon
  from '@/Components/App/Global/Icons/ExclamationLgIcon.vue'
import OrgboardLgIcon from '@/Components/App/Global/Icons/OrgboardLgIcon.vue'
import MagnifySmIcon from '@/Components/App/Global/Icons/MagnifySmIcon.vue'
import MagnifyLgIcon from '@/Components/App/Global/Icons/MagnifyLgIcon.vue'
import LaunchSmIcon from '@/Components/App/Global/Icons/LaunchSmIcon.vue'
import LaunchLgIcon from '@/Components/App/Global/Icons/LaunchLgIcon.vue'
import FlagUS from '@/Components/Shared/Flags/FlagUS.vue'
import FlagMX from '@/Components/Shared/Flags/FlagMX.vue'
import FlagES from '@/Components/Shared/Flags/FlagES.vue'
import FlagIT from '@/Components/Shared/Flags/FlagIT.vue'
import CalculatorSmIcon
  from '@/Components/App/Global/Icons/CalculatorSmIcon.vue'
import QuillSmIcon from '@/Components/App/Global/Icons/QuillSmIcon.vue'
import QuillLgIcon from '@/Components/App/Global/Icons/QuillLgIcon.vue'
import CalendarSmIcon from '@/Components/App/Global/Icons/CalendarSmIcon.vue'
import CalendarLgIcon from '@/Components/App/Global/Icons/CalendarLgIcon.vue'
import NewsLgIcon from '@/Components/App/Global/Icons/NewsLgIcon.vue'

export interface AppIcon {
  component: unknown
  name?: string
  hero?: unknown
  heroBig?: unknown
  hero2?: unknown
  solid?: unknown
  mini?: unknown
  micro?: unknown
  outline?: unknown
}

export const appIcons = computed<{
  [index: string]: AppIcon
}>(() => ({
  success: {
    component: CheckCircleIcon,
    solid: CheckCircleIconSolid,
  },
  neutral: {
    component: InformationCircleIcon,
    heroBig: InformationLgIcon,
    solid: InformationCircleIconSolid,
  },
  info: {
    component: InformationCircleIcon,
    heroBig: InformationLgIcon,
    solid: InformationCircleIconSolid,
  },
  warning: {
    component: ExclamationCircleIcon,
    solid: ExclamationCircleIconSolid,
  },
  danger: {
    component: ExclamationTriangleIcon,
    heroBig: ExclamationLgIcon,
    solid: ExclamationTriangleIconSolid,
  },
  forbidden: {
    component: ShieldExclamationIcon,
  },
  edit: {
    component: PencilSquareIcon,
  },
  checklist: {
    component: ClipboardDocumentCheckIcon,
    hero: FormSmIcon,
    heroBig: FormLgIcon,
    solid: ClipboardDocumentCheckIconSolid,
    mini: ClipboardDocumentCheckIconMini,
  },
  battlePlan: {
    component: DocumentCheckIcon,
  },
  actionPlan: {
    component: DocumentCheckIcon,
    hero: NotePadSmIcon,
    heroBig: NotePadLgIcon,
    solid: DocumentCheckIconSolid,
    mini: DocumentCheckIconMini,
  },
  ai: {
    component: OhVueIcon,
    name: 'la-robot-solid',
  },
  post: {
    component: NewspaperIcon,
    hero: NewsSmIcon,
    heroBig: NewsLgIcon,
    solid: NewspaperIconSolid,
    mini: NewspaperIconMini,
  },
  adminScale: {
    component: FlagIcon,
  },
  program: {
    component: BriefcaseIcon,
    hero: BriefcaseSmIcon,
    heroBig: BriefcaseLgIcon,
    solid: BriefcaseIconSolid,
    mini: BriefcaseIconMini,
  },
  project: {
    component: ClipboardDocumentListIcon,
    hero: FolderSmIcon,
    heroBig: FolderLgIcon,
    solid: ClipboardDocumentListIconSolid,
    mini: ClipboardDocumentListIconMini,
  },
  target: {
    component: CheckCircleIcon,
    hero: TargetSmIcon,
    heroBig: TargetLgIcon,
    solid: CheckCircleIconSolid,
    mini: CheckCircleIconMini,
  },
  stat: {
    component: PresentationChartLineIcon,
    hero: ChartSmIcon,
    heroBig: ChartLgIcon,
    hero2: PieChartSmIcon,
    solid: PresentationChartLineIconSolid,
    mini: PresentationChartLineIconMini,
  },
  statValue: {
    component: CalculatorIcon,
    hero: CalculatorSmIcon,
  },
  allTeamsSearch: {
    component: MagnifyingGlassCircleIcon,
  },
  search: {
    component: MagnifyingGlassCircleIcon,
    hero: MagnifySmIcon,
    heroBig: MagnifyLgIcon,
  },
  teams: {
    component: OhVueIcon,
    name: 'md-groups',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  teamMembers: {
    component: UsersIcon,
    hero: UserPlusSmIcon,
  },
  hat: {
    component: IdentificationIcon,
    outline: IdentificationIcon,
    hero: IdentificationSmIcon,
    heroBig: IdentificationLgIcon,
    solid: IdentificationIconSolid,
    mini: IdentificationIconMini,
  },
  publication: {
    component: OhVueIcon,
    name: 'bi-megaphone-fill',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  teamRoles: {
    component: LockClosedIcon,
    hero: ShieldLockSmIcon,
  },
  newMember: {
    component: UserPlusIcon,
    hero: UserPlusSmIcon,
  },
  teamInvitation: {
    component: EnvelopeOpenIcon,
    hero: EnvelopeOpenSmIcon,
  },
  languages: {
    component: LanguageIcon,
  },
  organization: {
    component: BuildingOffice2Icon,
  },
  billing: {
    component: CreditCardIcon,
  },
  membership: {
    component: OhVueIcon,
    name: 'bi-patch-check',
  },
  group: {
    component: UserGroupIcon,
    solid: UserGroupIconSolid,
    mini: UserGroupIconMini,
    hero: ShopSmIcon,
    heroBig: ShopLgIcon,
  },
  assignee: {
    component: UsersIcon,
    hero: UserPlusSmIcon,
    outline: UsersIcon,
    solid: UsersIconSolid,
    mini: UsersIconMini,
  },
  orgboard: {
    component: OhVueIcon,
    name: 'ri-organization-chart',
    hero: HomeSmIcon,
    heroBig: OrgboardLgIcon,
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  groups: {
    component: OhVueIcon,
    name: 'io-people-circle-outline',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  attachment: {
    component: CloudArrowUpIcon,
    outline: CloudArrowUpIcon,
    hero: CloudUploadSmIcon,
    solid: CloudArrowUpIconSolid,
    mini: CloudArrowUpIconMini,
  },
  comment: {
    component: ChatBubbleLeftRightIcon,
    hero: ChatSmIcon,
    outline: ChatBubbleLeftRightIcon,
    solid: ChatBubbleLeftRightIconSolid,
    mini: ChatBubbleLeftRightIconMini,
  },
  profile: {
    component: UserCircleIcon,
  },
  expand: {
    component: OhVueIcon,
    name: 'bi-arrows-angle-expand',
  },
  contract: {
    component: OhVueIcon,
    name: 'bi-arrows-angle-contract',
  },
  share: {
    component: ShareIcon,
  },
  link: {
    component: LinkIcon,
    hero: PuzzleSmIcon,
    solid: LinkIconSolid,
    mini: LinkIconMini,
  },
  strategy: {
    component: FlagIcon,
    hero: FlagSmIcon,
    heroBig: FlagLgIcon,
    solid: FlagIconSolid,
    mini: FlagIconMini,
  },
  strategicPlan: {
    component: LightBulbIcon,
    hero: LightBulbSmIcon,
    heroBig: LightBulbLgIcon,
    solid: LightBulbIconSolid,
    mini: LightBulbIconMini,
  },
  loadRecent: {
    component: ClockIcon,
  },
  trash: {
    component: TrashIcon,
    outline: TrashIcon,
    hero: TrashSmIcon,
    solid: TrashIconSolid,
    mini: TrashIconMini,
  },
  unlink: {
    component: LinkSlashIcon,
    outline: LinkSlashIcon,
    solid: LinkSlashIconSolid,
    mini: LinkSlashIconMini,
  },
  view: {
    component: EyeIcon,
    solid: EyeIconSolid,
    mini: EyeIconMini,
  },
  tag: {
    component: TagIcon,
    hero: TagSmIcon,
    outline: TagIcon,
    solid: TagIconSolid,
    mini: TagIconMini,
  },
  languageEn: {
    component: FlagUS,
  },
  languageIt: {
    component: FlagIT,
  },
  languageLatam: {
    component: FlagMX,
  },
  languageEs: {
    component: FlagES,
  },
  // GPT-5 family
  gpt52: {
    component: OhVueIcon,
    name: 'si-openai',
    mini: OhVueIcon,
  },

  gpt51: {
    component: OhVueIcon,
    name: 'si-openai',
    mini: OhVueIcon,
  },

  gpt5: {
    component: OhVueIcon,
    name: 'si-openai',
    mini: OhVueIcon,
  },

  gpt5Mini: {
    component: OhVueIcon,
    name: 'gi-robot-helmet',
    mini: OhVueIcon,
  },

  gpt5Nano: {
    component: OhVueIcon,
    name: 'gi-vintage-robot',
    mini: OhVueIcon,
  },

  gpt5Pro: {
    component: OhVueIcon,
    name: 'gi-robot-golem',
    mini: OhVueIcon,
  },

  gpt52Pro: {
    component: OhVueIcon,
    name: 'gi-mecha-head',
    mini: OhVueIcon,
  },

  // GPT-4.1 family
  gpt41: {
    component: OhVueIcon,
    name: 'gi-robot-golem',
    mini: OhVueIcon,
  },

  gpt41Mini: {
    component: OhVueIcon,
    name: 'gi-robot-helmet',
    mini: OhVueIcon,
  },

  gpt41Nano: {
    component: OhVueIcon,
    name: 'gi-vintage-robot',
    mini: OhVueIcon,
  },

  // GPT-4o
  gpt4O: {
    component: OhVueIcon,
    name: 'gi-tracked-robot',
    mini: OhVueIcon,
  },

  standardPublicAssistant: {
    component: OhVueIcon,
    name: 'gi-tracked-robot',
    mini: OhVueIcon,
  },
  standardPublicMiniAssistant: {
    component: OhVueIcon,
    name: 'gi-mono-wheel-robot',
    mini: OhVueIcon,
  },
  standardPublicOneAssistant: {
    component: OhVueIcon,
    name: 'gi-robot-golem',
    mini: OhVueIcon,
  },
  standardPublicOneMiniAssistant: {
    component: OhVueIcon,
    name: 'gi-robot-helmet',
    mini: OhVueIcon,
  },
  standardPublicOneNanoAssistant: {
    component: OhVueIcon,
    name: 'gi-vintage-robot',
    mini: OhVueIcon,
  },
  options: {
    outline: WrenchScrewdriverIcon,
    component: WrenchScrewdriverIcon,
    solid: WrenchScrewdriverIconSolid,
    mini: WrenchScrewdriverIconMini,
  },
  upgrade: {
    hero: LaunchSmIcon,
    heroBig: LaunchLgIcon,
  },
  facebook: {
    component: OhVueIcon,
    name: 'fa-facebook-f',
  },
  twitter: {
    component: OhVueIcon,
    name: 'fa-twitter',
  },
  linkedin: {
    component: OhVueIcon,
    name: 'fa-linkedin-in',
  },
  whatsapp: {
    component: OhVueIcon,
    name: 'fa-whatsapp',
  },
  telegram: {
    component: OhVueIcon,
    name: 'fa-telegram-plane',
  },
  pinterest: {
    component: OhVueIcon,
    name: 'fa-pinterest-p',
  },
  reddit: {
    component: OhVueIcon,
    name: 'fa-reddit-alien',
  },
  email: {
    component: OhVueIcon,
    name: 'fa-envelope',
  },
  systemTheme: {
    component: ComputerDesktopIcon,
  },
  lightTheme: {
    component: SunIcon,
  },
  darkTheme: {
    component: MoonIcon,
  },
  catalogCurrent: {
    component: ShoppingCartIcon,
    solid: ShoppingCartIconSolid,
    mini: ShoppingCartIconMini,
  },
  catalogAllTeams: {
    component: OhVueIcon,
    name: 'la-city-solid',
  },
  catalogAll: {
    component: OhVueIcon,
    name: 'la-globe-solid',
  },
  catalogPublicOnly: {
    component: OhVueIcon,
    name: 'la-universal-access-solid',
  },
  home: {
    component: HomeIcon,
  },
  blog: {
    component: OhVueIcon,
    name: 'hi-solid-newspaper',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  training: {
    component: OhVueIcon,
    name: 'la-school-solid',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  guide: {
    component: OhVueIcon,
    name: 'hi-solid-book-open',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  dashboardPlanning: {
    component: OhVueIcon,
    name: 'md-dashboardcustomize-outlined',
    solid: OhVueIcon,
    mini: OhVueIcon,
  },
  notStarted: {
    component: ClockIcon,
    solid: ClockIconSolid,
  },
  inProgress: {
    component: ArrowPathIcon,
    solid: ArrowPathIconSolid,
  },
  stalled: {
    component: ExclamationTriangleIcon,
    solid: ExclamationTriangleIconSolid,
  },
  cancelled: {
    component: XCircleIcon,
    solid: XCircleIconSolid,
  },
  done: {
    component: CheckCircleIcon,
    solid: CheckCircleIconSolid,
  },
  richTextEditor: {
    component: OhVueIcon,
    name: 'gi-quill-ink',
    hero: QuillSmIcon,
    heroBig: QuillLgIcon,
  },
  periodDay: {
    component: OhVueIcon,
    name: 'bi-calendar2-day-fill',
  },
  periodWeek: {
    component: OhVueIcon,
    name: 'bi-calendar2-week-fill',
  },
  periodMonth: {
    component: OhVueIcon,
    name: 'bi-calendar2-month-fill',
  },
  periodQuarter: {
    component: OhVueIcon,
    name: 'bi-calendar2-range-fill',
  },
  periodSemester: {
    component: OhVueIcon,
    name: 'bi-calendar2-event-fill',
  },
  periodYear: {
    component: OhVueIcon,
    name: 'bi-calendar2-fill',
  },
  calendarDay: {
    component: OhVueIcon,
    name: 'la-calendar-day-solid',
  },
  backwards: {
    component: OhVueIcon,
    name: 'io-arrow-undo-sharp',
  },
  forwards: {
    component: OhVueIcon,
    name: 'io-arrow-redo-sharp',
  },
  calendar: {
    component: OhVueIcon,
    name: 'io-arrow-redo-sharp',
    hero: CalendarSmIcon,
    heroBig: CalendarLgIcon,
  },
  diagram: {
    component: OhVueIcon,
    mini: OhVueIcon,
    name: 'bi-diagram-3-fill',
  },
}))

type IconsKey = keyof typeof appIcons.value
export const getAppIcon = (item: IconsKey): AppIcon =>
  appIcons.value[_.camelCase(item)]
